document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('js-l-header');
  const darkSections = document.querySelectorAll('.js-header-dark-section');

  if (!header) {
    return;
  }

  // Function to check if two DOM rectangles overlap
  const doRectsOverlap = (rect1, rect2) => {
    return !(
      rect1.right < rect2.left ||
      rect1.left > rect2.right ||
      rect1.bottom < rect2.top ||
      rect1.top > rect2.bottom
    );
  };

  let lastScrollY = window.scrollY;
  let ticking = false;

  const updateHeader = () => {
    // Color change logic
    if (darkSections.length > 0) {
      const headerRect = header.getBoundingClientRect();
      let isOverlappingWithAnyDarkSection = false;

      for (let i = 0; i < darkSections.length; i++) {
        const darkSectionRect = darkSections[i].getBoundingClientRect();
        if (doRectsOverlap(headerRect, darkSectionRect)) {
          isOverlappingWithAnyDarkSection = true;
          break;
        }
      }

      if (isOverlappingWithAnyDarkSection) {
        header.classList.add('l-header--white');
      } else {
        header.classList.remove('l-header--white');
      }
    }

    // Scroll direction logic
    const currentScrollY = window.scrollY;
    const headerHeight = header.offsetHeight;
    const scrollDiff = currentScrollY - lastScrollY;

    if (Math.abs(scrollDiff) > 10) {
      if (currentScrollY > lastScrollY && currentScrollY > headerHeight) {
        // Scrolling down
        header.classList.add('is-hidden');
        header.classList.remove('is-scrolled');
      } else {
        // Scrolling up
        header.classList.remove('is-hidden');
        if (currentScrollY > headerHeight) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
        }
      }
      lastScrollY = currentScrollY;
    }

    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  });

  // Initial check on load
  updateHeader();

  // -------------------------------------------------------------------------
  // Current Navigation Highlight
  // -------------------------------------------------------------------------
  const currentPath = window.location.pathname;
  const navItems = document.querySelectorAll('.l-header-navigation__item');

  navItems.forEach(item => {
    const link = item.querySelector('.l-header-navigation__link');
    if (link) {
      const href = link.getAttribute('href');
      // Check if current path matches the link
      // For home page, exact match. For others, startsWith to handle sub-pages.
      if (href === '/') {
        if (currentPath === '/') {
          item.classList.add('is-current');
        }
      } else if (currentPath.startsWith(href)) {
        item.classList.add('is-current');
      }
    }
  });

  // -------------------------------------------------------------------------
  // Mobile Accordion Toggle
  // -------------------------------------------------------------------------
  const toggleIcons = document.querySelectorAll('.l-header-navigation__toggle-icon');
  toggleIcons.forEach(icon => {
    icon.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const item = icon.closest('.l-header-navigation__item');
      item.classList.toggle('is-open');
    });
  });

  // -------------------------------------------------------------------------
  // Mega Menu Mask Logic (Desktop)
  // -------------------------------------------------------------------------
  const megaMenuTriggers = document.querySelectorAll('.js-mega-menu-trigger');

  megaMenuTriggers.forEach(trigger => {
    trigger.addEventListener('mouseenter', () => {
      if (window.matchMedia('(min-width: 1025px)').matches) {
        header.classList.add('is-active');
      }
    });

    trigger.addEventListener('mouseleave', () => {
      if (window.matchMedia('(min-width: 1025px)').matches) {
        header.classList.remove('is-active');
      }
    });
  });
});
